import { Heading, Layout, Loading } from '@components'
import { api } from '@here/api'
import { user } from '@state'
import { ListChecks } from 'lucide-solid'
import { ErrorBoundary, For, Show, createResource } from 'solid-js'
import { Container, Grid } from 'styled-system/jsx'
import Task from './Task'

export default function () {
	const [resource] = createResource(
		() => user()?.user.id,
		async (userId: string) => {
			const client = api()

			// Step 1: Fetch user's potential_high_quality with setup.symbol
			const { data: potentialHighQuality, error: phqError } = await client
				.from('potential_high_quality')
				.select(`
					*,
					setup:setup_id (
						id,
						symbol
					)
				`)
			if (phqError) throw phqError

			const setupIds = [...new Set(potentialHighQuality.map((phq) => phq.setup_id))]

			if (setupIds.length === 0) return []

			// Step 2: Fetch taken_setups for those setup_ids
			const { data: takenSetups, error: tsError } = await client
				.from('taken_setups')
				.select('setup_id')
				.eq('user_id', userId)
				.in('setup_id', setupIds)

			if (tsError) throw tsError

			const takenSetupIds = new Set(takenSetups.map((ts) => ts.setup_id))

			// Step 3: Filter out rows where user has already scored that setup
			const unscored = potentialHighQuality.filter(
				(phq) => !takenSetupIds.has(phq.setup_id),
			)

			return unscored
		},
	)

	return (
		<ErrorBoundary fallback={<p>{resource.error}</p>}>
			<Show
				when={!resource.loading}
				fallback={<Loading />}
			>
				<Container width="100%">
					<Layout
						maxW="700px"
						margin="0 auto"
					>
						<Heading>Potential High Quality</Heading>

						<Grid>
							<For
								each={resource()}
								fallback={
									<Grid
										justifyItems="center"
										mt={32}
										gap={4}
									>
										<Heading
											size="3xl"
											children="No Setups to Review"
										/>
										<ListChecks size={150} />
									</Grid>
								}
							>
								{(poentialHighQuality) => (
									<Task poentialHighQuality={poentialHighQuality} />
								)}
							</For>
						</Grid>
					</Layout>
				</Container>
			</Show>
		</ErrorBoundary>
	)
}
